// extracted by mini-css-extract-plugin
export var chart = "weatherWidget-module--chart--msax3";
export var dummy = "weatherWidget-module--dummy--diEIQ";
export var weatherWidget = "weatherWidget-module--weatherWidget--YXRSD";